import { TutorCardsActionType, TutorsPayload } from './actions';
import { logSafelyToConsole } from 'utils';
import { ITutorProfileListItem } from 'types';

const {
  SEARCH_TUTORS_REQUEST,
  SEARCH_TUTORS_SUCCESS,
  SEARCH_TUTORS_ERROR
} = TutorCardsActionType;

export interface TutorCardsState {
  loading: boolean;
  tutors: ITutorProfileListItem[];
  totalCount: number;
}

export default function reducer(
  state: TutorCardsState,
  action: {
    type: TutorCardsActionType;
    payload: TutorsPayload | null;
  }
): TutorCardsState {
  const { type, payload } = action;

  logSafelyToConsole(type);
  switch (type) {
    case SEARCH_TUTORS_REQUEST: {
      return {
        ...state,
        loading: true
      };
    }
    case SEARCH_TUTORS_SUCCESS: {
      if (payload) {
        const { tutors } = payload;
        return {
          ...state,
          loading: false,
          tutors
        };
      } else {
        return {
          ...state,
          loading: false,
          tutors: []
        };
      }
    }
    case SEARCH_TUTORS_ERROR: {
      return {
        ...state,
        loading: false,
        tutors: []
      };
    }
    default:
      return state;
  }
}
